import { Component } from '@angular/core';

@Component({
  selector: 'app-fuel-oil-icon',
  templateUrl: './fuel-oil-icon.component.svg',
  styleUrls: ['./fuel-oil-icon.component.scss']
})
export class FuelOilIconComponent
{

  constructor() { }

}
